import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { PapiUser, PapiDeviation } from '@wix/da-types-papi';
import { IconSize } from '@wix/da-shared-react/pkg/Icons/IconWrap';
import PointsIcon from '@wix/da-shared-react/pkg/Icons/Points';
import Button from '@wix/da-shared-react/pkg/Button';
import WatchButton from '@wix/da-shared-react/pkg/Button/ProfileOwnerWatchButton';
import BasePaywall from '../BasePaywall';
import { URLS } from '@wix/da-url';
import s from './DeviationPaywall.scss';

export interface Props {
  premiumFolderData?: PapiDeviation['premiumFolderData'];
  contentOwner: PapiUser;
  children: React.ReactNode;
}

const DeviationPaywall: React.FC<Props> = ({
  contentOwner,
  premiumFolderData,
  children,
}) => {
  const { t } = useTranslation();
  const { type, hasAccess, pointsPrice, dollarPrice } = premiumFolderData || {};
  const unlockUrl = URLS.CORE_MEMBERSHIP; // TODO: This will trigger the unlock folder popup
  return (
    <>
      {!hasAccess && type === 'paid' && (
        <BasePaywall
          icon={<div className={s['illustration-pcp']} />}
          title={t('paywall.premium.deviation.title')}
          text={
            <Trans i18nKey="paywall.premium.deviation.text">
              To view, unlock its <a href={unlockUrl}>Premium Folder</a> - and
              support the artist!
            </Trans>
          }
          button={
            <Button view="b18" href={unlockUrl}>
              <span className={s['buttonLabel']}>
                {t('paywall.premium.deviation.unlockFor')} ${dollarPrice} /{' '}
                <PointsIcon size={IconSize.TINY} disableDefaultColors />
                {pointsPrice}
              </span>
            </Button>
          }
        >
          {children}
        </BasePaywall>
      )}
      {!hasAccess && type === 'watchers' && (
        <BasePaywall
          icon={<div className={s['illustration-watchers']} />}
          title={t('paywall.watchersOnly.deviation.title')}
          text={t('paywall.watchersOnly.deviation.text')}
          button={<WatchButton view="b1" user={contentOwner!} />}
        >
          {children}
        </BasePaywall>
      )}
      {(hasAccess || !type) && children}
    </>
  );
};
DeviationPaywall.displayName = 'DeviationPaywall';

export default DeviationPaywall;
